import { Box, RenderHtml, Text } from '@betty/moonlight';
import { memo } from 'react';
import { PromoTermsProps } from './PromoTerms.types';

function PromoTerms({ description, termsAndConditions }: PromoTermsProps) {
  return (
    <Box
      marginTop="space-200"
      padding="space-400"
      marginLeft="-space-400"
      marginRight="-space-400"
      gap="space-200"
      backgroundColor="secondaryBackgroundDefault"
      borderRadius={{
        mobile: undefined,
        tablet: 'radius-400',
        desktop: 'radius-400',
      }}
    >
      <Box>
        <Text
          variant="h5"
          gradient="darkSurfaceAccent"
          locNS="promos"
          locKey="howItWorks"
        />
        {description ? (
          <RenderHtml html={description} variant="body-m-semi" />
        ) : null}
      </Box>
      <Box>
        <Text
          variant="h5"
          gradient="darkSurfaceAccent"
          locNS="promos"
          locKey="terms"
        />
        {termsAndConditions ? (
          <RenderHtml html={termsAndConditions} variant="body-m-semi" />
        ) : null}
      </Box>
    </Box>
  );
}

export default memo(PromoTerms);
